"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioButtonWithLabelGroupWidget = exports.RadioLayoutType = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var Colors_1 = require("../../styles/Colors");
var TabStyles_1 = require("../../styles/TabStyles");
var Declarative_1 = require("../../utils/Declarative");
var DomUtil_1 = require("../../utils/DomUtil");
var ReactHelpers_1 = require("../../utils/ReactHelpers");
var SelectorShims_1 = require("./SelectorShims");
var RadioLayoutType;
(function (RadioLayoutType) {
    RadioLayoutType[RadioLayoutType["Veritical"] = 0] = "Veritical";
    RadioLayoutType[RadioLayoutType["Horizontal"] = 1] = "Horizontal";
})(RadioLayoutType = exports.RadioLayoutType || (exports.RadioLayoutType = {}));
var StyleName = TypeStyle.style({
    color: Colors_1.TextColors.Primary,
    fontSize: TabStyles_1.TabStyles.Typography.Sizing.Default,
    $nest: {
        '&.horizontal': { display: 'flex', flexWrap: 'wrap' },
        '&.horizontal.justify': { justifyContent: 'space-between' },
        '&.horizontal > :not(:last-child)': { marginRight: TabStyles_1.TabStyles.Spacing.ExtraLargeSpace },
    }
});
/** Displays a group of radio options */
var RadioButtonWithLabelGroupWidget = /** @class */ (function (_super) {
    tslib_1.__extends(RadioButtonWithLabelGroupWidget, _super);
    function RadioButtonWithLabelGroupWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.groupId = DomUtil_1.generateId();
        if (!props.label && !(props['aria-label']) && !props['aria-labelledby']) {
            console.trace('`label`, `aria-label`, or `aria-labelledby` must be provided for every radio group');
        }
        return _this;
    }
    RadioButtonWithLabelGroupWidget.prototype.render = function () {
        var _this = this;
        var _a;
        // eslint-disable-next-line max-len
        var _b = this.props, buttonList = _b.buttonList, checkedIndex = _b.checkedIndex, handleChange = _b.handleChange, justifyHorizontalItems = _b.justifyHorizontalItems, label = _b.label, layout = _b.layout, name = _b.name, removeLeftMargin = _b.removeLeftMargin, testId = _b.testId, htmlAttrs = tslib_1.__rest(_b, ["buttonList", "checkedIndex", "handleChange", "justifyHorizontalItems", "label", "layout", "name", "removeLeftMargin", "testId"]);
        var hasDetail = buttonList.some(function (button) { return button.detail; });
        var buttons = buttonList.map(function (_a, index) {
            var detail = _a.detail, buttonOption = tslib_1.__rest(_a, ["detail"]);
            return React.createElement(SelectorShims_1.RadioButtonWithLabelWidget, tslib_1.__assign({}, buttonOption, { checked: index === checkedIndex, groupName: name || _this.groupId, handleChange: handleChange, index: index, key: index, removeLeftMargin: removeLeftMargin }));
        }).map(function (buttonElem, index) {
            var _a;
            if (!hasDetail) {
                return buttonElem;
            }
            var _b = buttonList[index], detail = _b.detail, disabled = _b.disabled;
            var detailId = _this.groupId + "-" + index;
            return React.createElement("div", { key: index },
                React.cloneElement(buttonElem, { 'aria-describedby': (_a = buttonElem.props['aria-describedby']) !== null && _a !== void 0 ? _a : detailId }),
                detail && React.createElement("div", { style: { color: disabled ? Colors_1.TextColors.Disabled : undefined, marginLeft: removeLeftMargin ? 20 : 26 }, id: detailId }, detail));
        });
        var labelId = label ? this.groupId + '-label' : undefined;
        return (React.createElement("div", tslib_1.__assign({ "data-tb-test-id": Declarative_1.makeTestId('RadioButtonWithLabelGroupWidget', testId) }, htmlAttrs, { "aria-labelledby": (_a = htmlAttrs['aria-labelledby']) !== null && _a !== void 0 ? _a : labelId, className: TypeStyle.classes(StyleName, htmlAttrs.className, {
                horizontal: layout === RadioLayoutType.Horizontal,
                justify: justifyHorizontalItems,
            }), role: 'radiogroup' }),
            label && React.createElement(RadioGroupLabel, { children: label, id: labelId }),
            buttons));
    };
    return RadioButtonWithLabelGroupWidget;
}(React.Component));
exports.RadioButtonWithLabelGroupWidget = RadioButtonWithLabelGroupWidget;
var LabelStyleName = TypeStyle.style({ height: "21px", lineHeight: "21px" });
var RadioGroupLabel = function (props) {
    var onClick = props.onClick, htmlAttrs = tslib_1.__rest(props, ["onClick"]);
    var handleClick = React.useCallback(function (e) {
        if (!e.currentTarget.htmlFor) {
            return;
        }
        var focusTarget = document.getElementById(e.currentTarget.htmlFor);
        if (focusTarget && !(focusTarget.tabIndex === null || focusTarget.tabIndex === undefined)) {
            focusTarget.focus();
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }, [onClick]);
    return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control, jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    React.createElement("label", tslib_1.__assign({}, htmlAttrs, ReactHelpers_1.EventUtilsOptOut, { className: LabelStyleName, onClick: handleClick })));
};
RadioGroupLabel.displayName = 'RadioGroupLabel';
//# sourceMappingURL=RadioButtonWithLabelGroupWidget.js.map